<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions :column="3" :label-style="{ width: '20%' }" bordered>
    <a-descriptions-item label="Novo gerente negocial responsável" :span="3">
      {{ props.compromisso.data.gerenteNegocialResponsavelNovoNome }}
    </a-descriptions-item>
    <a-descriptions-item label="Gerente negocial responsável antigo" :span="3">
      {{ props.compromisso.data.gerenteNegocialResponsavelAntigoNome }}
    </a-descriptions-item>
  </a-descriptions>
</template>
